import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Star } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent } from '@/components/ui/card';
import { formatBlogDate, getBlogPostPath, resolveBlogExcerpt } from '@/utils/blog';

const FeaturedBlogTeaser = ({ post, className = '' }) => {
  if (!post?.slug) {
    return null;
  }

  const articlePath = getBlogPostPath(post.slug);
  const excerpt = resolveBlogExcerpt(post);

  return (
    <section className={`bg-white py-14 sm:py-16 ${className}`} data-testid="landing-featured-blog">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Card className="overflow-hidden rounded-[2rem] border border-red-100/80 bg-gradient-to-br from-white via-red-50/80 to-cyan-50 shadow-[0_24px_80px_-50px_rgba(15,23,42,0.45)]">
          <CardContent className="p-0">
            <div className="grid gap-0 lg:grid-cols-[1.1fr_0.9fr] lg:items-stretch">
              <div className="flex flex-col justify-center gap-5 p-6 sm:p-8 lg:p-10">
                <div className="flex flex-wrap items-center gap-3">
                  <Badge className="bg-red-600 text-white">
                    <Star className="mr-1 h-3.5 w-3.5" />
                    Article en avant
                  </Badge>
                  <span className="text-sm font-medium text-slate-500">{formatBlogDate(post?.created_at)}</span>
                </div>

                <div className="space-y-4">
                  <p className="text-sm font-semibold uppercase tracking-[0.24em] text-cyan-700">Blog Coli Noki</p>
                  <h2 className="text-3xl font-semibold tracking-tight text-slate-950 sm:text-4xl">
                    {post?.title}
                  </h2>
                  <p className="max-w-2xl text-base leading-8 text-slate-600 sm:text-lg">
                    {excerpt}
                  </p>
                </div>

                <div className="flex flex-wrap items-center gap-4">
                  <Button asChild className="rounded-full bg-red-600 px-6 text-white hover:bg-red-700">
                    <Link to={articlePath}>
                      Voir plus
                      <ArrowRight className="ml-2 h-4 w-4" />
                    </Link>
                  </Button>
                  <p className="text-sm text-slate-500">
                    Par {post?.author || 'Equipe Coli Noki'}
                  </p>
                </div>
              </div>

              <div className="relative min-h-[260px] overflow-hidden bg-slate-100">
                {post?.cover_image_url ? (
                  <img
                    src={post.cover_image_url}
                    alt={post?.title || 'Article en avant Coli Noki'}
                    loading="lazy"
                    className="h-full w-full object-cover"
                  />
                ) : (
                  <div className="flex h-full min-h-[260px] items-end bg-gradient-to-br from-red-500 via-red-600 to-cyan-500 p-8">
                    <div className="rounded-3xl bg-white/14 px-4 py-3 backdrop-blur">
                      <p className="text-xs font-semibold uppercase tracking-[0.28em] text-white/80">Coli Noki Story</p>
                      <p className="mt-2 max-w-xs text-xl font-semibold text-white">
                        Des conseils logistiques, commerce et livraison pour vos ventes.
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default FeaturedBlogTeaser;
